import { render, staticRenderFns } from "./SingleClientKogi.vue?vue&type=template&id=6fd668c7&scoped=true&"
import script from "./SingleClientKogi.vue?vue&type=script&lang=js&"
export * from "./SingleClientKogi.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientKogi.vue?vue&type=style&index=0&id=6fd668c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd668c7",
  null
  
)

export default component.exports